if (Feature.isActive('ADVANCED_PRODUCT_CATALOGS')) {
    PluginManager.register('B2bAdvancedProductCatalogs', () => import('./plugin/advanced-product-catalogs.plugin'), '[data-b2b-advanced-product-catalogs]');
}

if (Feature.isActive('ADVANCED_PRODUCT_CATALOGS') && !!PluginManager.getPlugin('B2bOrganizationUnitFormValidation')) {
    PluginManager.override('B2bOrganizationUnitFormValidation', () => import('./plugin/forms/organization-form-validation.plugin'), '[data-b2b-organization-unit-form-validation]');
}
